import BaseFactory from 'services/sports/default/base-factory';
import Player from './player';
import PlayerTiers from './player-tiers';
import Const from 'constants';

const classesMap = {
    [Const.GAME_TYPE_CLASSIC]: Player,
    [Const.GAME_TYPE_SHOWDOWN]: Player,
    [Const.GAME_TYPE_TIERS]: PlayerTiers,
};

class Factory extends BaseFactory {
    createObj(objectName, params) {
        const {sportConfig} = params;
        const gameType = sportConfig.getGameType();

        if (gameType in classesMap) {
            return new classesMap[gameType](params);
        }

        return new Player(params);
    }
}

export {Factory};
